module.exports = __webpack_public_path__ + "static/media/favicon2.9d889fa6.png";